/*global $, document, window, setTimeout, alert, FG, Lawnchair */
(function () {
    "use strict";

    /**
     * FrontGate JS database class to persist data on the frontend
     * @returns {FG.DB}
     * @constructor
     * @depends lawnchair-0.6.1.min.js
     */
    FG.DB = function () {
        return this;
    };

   FG.DB.prototype = {

        /**
         * Database name
         * @param {string}
         */
        database: 'fgdb',

        /**
         * @constructor
         */
        constructor: FG.DB,

        /**
         * Set a value to the store.
         * @param {string}  key     Key name
         * @param val     Value to store in key
         * @return bool
         */
        set: function (key, val) {
            return $.jStorage.set(key, val);
        },

        /**
         * Get a value from the store.
         * @param {string}  key     Key name
         * @return mixed
         */
        get: function (key) {
            return $.jStorage.get(key);
        },

        /**
         * Does database have the key you are looking for?
         * @param {string}  key     Key name
         * @return boolean
         */
        has: function (key) {
            var data = this.get(key);
            return typeof data !== 'undefined' && data !== null;
        },

        /**
         * Delete a value from the store.
         * @param {string}  key     Key name
         * @return bool
         */
        remove: function (key) {
            return $.jStorage.deleteKey(key);
        },

        /**
         * Delete everything from the store
         * @return bool
         */
        nuke: function () {
            return $.jStorage.flush();
        }
    };
}());
